var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import HomeIndexListing from "../HomeIndexListing/HomeIndexListing";
import "./compositeIndex.scss";
import CompositeIndexLogo from "../../../../../../assets/img/composite-index-logo.svg";
import COMPOSITE_INDEX_IMG_CHEVRON from "../../../../../../assets/img/arrow-down.svg";
import { ReportsApi } from "../../../../../../core/api/reportsApi";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { Dropdown, Menu } from "antd";
import HomeIndex from "../HomeIndex/HomeIndex";
/**
 * Figma `1:4515` — RODA BI Composite Index panel; MCP `get_design_context`.
 * Embeds existing {@link HomeIndex} (`1:4547`) and {@link HomeIndexListing} (`1:4558`).
 */
const renderDropdown = (label, menu) => (React.createElement(Dropdown, { overlay: menu, trigger: ["click"] },
    React.createElement("div", { className: "composite-index__toolbar-tab composite-index__toolbar-tab--muted composite-index__toolbar-dropdown" },
        React.createElement("span", { className: "composite-index__toolbar-tab-label" }, label),
        React.createElement("span", { className: "composite-index__toolbar-chevron" },
            React.createElement("img", { alt: "", className: "composite-index__toolbar-chevron-img", src: COMPOSITE_INDEX_IMG_CHEVRON })))));
const CompositeIndex = () => {
    const [rows, setRows] = useState([]);
    const [graphKey, setGraphKey] = useState(0);
    const { promiseInProgress } = usePromiseTracker({
        area: "composite-index",
    });
    const [avgScore, setAvgScore] = useState(0);
    const [avgChange, setAvgChange] = useState({
        tone: "up-green",
        text: "",
    });
    const [rawData, setRawData] = useState([]);
    const [sortConfig, setSortConfig] = useState({
        type: null,
        order: null,
    });
    const ratingMenu = (React.createElement(Menu, { onClick: (e) => {
            setSortConfig({
                type: "rating",
                order: e.key,
            });
        }, className: "custom-dropdown-menu" },
        React.createElement(Menu.Item, { key: "desc" }, "Highest Rating"),
        React.createElement(Menu.Item, { key: "asc" }, "Lowest Rating")));
    const changeMenu = (React.createElement(Menu, { onClick: (e) => {
            setSortConfig({
                type: "change",
                order: e.key,
            });
        }, className: "custom-dropdown-menu" },
        React.createElement(Menu.Item, { key: "desc" }, "Highest Change"),
        React.createElement(Menu.Item, { key: "asc" }, "Lowest Change")));
    const scoreMenu = (React.createElement(Menu, { onClick: (e) => {
            setSortConfig({
                type: "score",
                order: e.key,
            });
        }, className: "custom-dropdown-menu" },
        React.createElement(Menu.Item, { key: "desc" }, "Highest Score"),
        React.createElement(Menu.Item, { key: "asc" }, "Lowest Score")));
    useEffect(() => {
        const handleResize = () => {
            setGraphKey((prev) => prev + 1);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        fetchHomeIndex();
    }, []);
    useEffect(() => {
        if (!(rawData === null || rawData === void 0 ? void 0 : rawData.length))
            return;
        const sortedData = sortData(rawData);
        const mapped = sortedData === null || sortedData === void 0 ? void 0 : sortedData.map((item, index) => {
            var _a;
            const isUp = (item === null || item === void 0 ? void 0 : item.change) >= 0;
            const tone = isUp ? "up-green" : "down-red";
            return {
                id: item === null || item === void 0 ? void 0 : item.id,
                companyId: item === null || item === void 0 ? void 0 : item.companyId,
                nodes: {
                    homeData: `api-${index}`,
                    homeText: `api-${index}`,
                    scoreData: `api-${index}`,
                    scoreText: `api-${index}`,
                    changeData: `api-${index}`,
                    changeText: `api-${index}`,
                    trendData: `api-${index}`,
                    trendText: `api-${index}`,
                    ratingData: `api-${index}`,
                    ratingPill: `api-${index}`,
                    ratingLabel: `api-${index}`,
                },
                homeName: item === null || item === void 0 ? void 0 : item.name,
                score: item === null || item === void 0 ? void 0 : item.score,
                change: {
                    tone,
                    text: `${isUp ? "▲" : "▼"} ${Math.abs((item === null || item === void 0 ? void 0 : item.change) || 0).toFixed(2)}`,
                },
                trend: (item === null || item === void 0 ? void 0 : item.trend) || "Stable",
                rating: {
                    variant: (_a = item === null || item === void 0 ? void 0 : item.rating) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                    label: item === null || item === void 0 ? void 0 : item.rating,
                },
            };
        });
        setRows(mapped);
    }, [rawData, sortConfig]);
    const sortData = (data) => {
        if (!sortConfig.type || !sortConfig.order)
            return data;
        const sorted = [...data];
        const dir = sortConfig.order === "asc" ? 1 : -1;
        switch (sortConfig.type) {
            case "rating": {
                const ratingRank = {
                    Strong: 3,
                    Stable: 2,
                    Vulnerable: 1,
                    Comp: 0,
                };
                sorted.sort((a, b) => { var _a, _b; return (((_a = ratingRank[a.rating]) !== null && _a !== void 0 ? _a : 0) - ((_b = ratingRank[b.rating]) !== null && _b !== void 0 ? _b : 0)) * dir; });
                break;
            }
            case "change": {
                sorted.sort((a, b) => (a.change - b.change) * dir);
                break;
            }
            case "score": {
                sorted.sort((a, b) => (a.score - b.score) * dir);
                break;
            }
        }
        return sorted;
    };
    const fetchHomeIndex = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const res = yield trackPromise(ReportsApi.getCompositeKey(), "composite-index");
            const avgScoreValue = Number(res === null || res === void 0 ? void 0 : res.avgScore) || 0;
            setAvgScore(avgScoreValue);
            const changeValue = Number((_a = res === null || res === void 0 ? void 0 : res.avgChange) !== null && _a !== void 0 ? _a : 0);
            if (changeValue === 0) {
                setAvgChange({
                    tone: "neutral-grey",
                    text: `| ${Math.abs(changeValue).toFixed(2)}`,
                });
            }
            else {
                const isUp = changeValue > 0;
                setAvgChange({
                    tone: isUp ? "up-green" : "down-red",
                    text: `${isUp ? "▲" : "▼"} ${Math.abs(changeValue).toFixed(2)}`,
                });
            }
            setRawData((res === null || res === void 0 ? void 0 : res.data) || []);
        }
        catch (error) {
            setRawData([]);
        }
    });
    return (React.createElement("div", { className: "composite-index", "data-node-id": "1:4515" },
        React.createElement("div", { className: "composite-index__scroll" },
            React.createElement("header", { className: "composite-index__header", "data-node-id": "1:4516" },
                React.createElement("div", { className: "composite-index__header-left", "data-node-id": "1:4517" },
                    React.createElement("div", { className: "composite-index__header-icon-wrap", "data-node-id": "1:4518", "data-name": "image 57" },
                        React.createElement("img", { alt: "", className: "composite-index__header-icon", src: CompositeIndexLogo })),
                    React.createElement("div", { className: "composite-index__header-copy", "data-node-id": "1:4519" },
                        React.createElement("p", { className: "composite-index__header-title", "data-node-id": "1:4520" }, "RODA BI COMPOSITE INDEX"),
                        React.createElement("p", { className: "composite-index__header-sub", "data-node-id": "1:4521" },
                            React.createElement("span", { className: "composite-index__header-sub-muted" },
                                "Weight by Revenue, Total Expenses, Net Profit, Balance Sheet, and Staffing",
                                " "),
                            React.createElement("span", { className: `composite-index__header-sub-accent composite-index__header-sub-accent--${avgChange.tone}` }, avgChange.text),
                            React.createElement("span", { className: "composite-index__header-sub-muted" }, " ")))),
                React.createElement("div", { className: "composite-index__header-right", "data-node-id": "1:4522" },
                    React.createElement("p", { className: "composite-index__header-score", "data-node-id": "1:4523" }, avgScore),
                    React.createElement("p", { className: "composite-index__header-caption", "data-node-id": "1:4524" }, "(Last 24 Hours)"))),
            React.createElement(HomeIndex, { key: graphKey }),
            React.createElement("div", { className: "composite-index__toolbar", "data-node-id": "1:4525" },
                React.createElement("div", { className: "composite-index__toolbar-gradient", "aria-hidden": true }),
                React.createElement("div", { className: "composite-index__toolbar-row", "data-node-id": "1:4526" },
                    React.createElement("div", { className: "composite-index__toolbar-filters", "data-node-id": "1:4527" },
                        React.createElement("button", { type: "button", className: "composite-index__toolbar-tab", "data-node-id": "1:4528" }, "RODABI INDEX DETAILS"),
                        renderDropdown("By Rating", ratingMenu),
                        renderDropdown("By Change", changeMenu),
                        renderDropdown("By Score", scoreMenu))),
                React.createElement("div", { className: "composite-index__toolbar-inset", "aria-hidden": true })),
            React.createElement(HomeIndexListing, { rows: rows, loading: promiseInProgress }),
            React.createElement("div", { className: "composite-index__legend", "data-node-id": "1:4620", "data-name": "Container" },
                React.createElement("div", { className: "composite-index__legend-gradient", "aria-hidden": true }),
                React.createElement("div", { className: "composite-index__legend-row", "data-node-id": "1:4621" },
                    React.createElement("div", { className: "composite-index__legend-item", "data-node-id": "1:4622" },
                        React.createElement("span", { className: "composite-index__legend-swatch composite-index__legend-swatch--strong", "data-node-id": "1:4623", "data-name": "Background+Border", "aria-hidden": true }),
                        React.createElement("p", { className: "composite-index__legend-label", "data-node-id": "1:4624" }, "Prime")),
                    React.createElement("div", { className: "composite-index__legend-item", "data-node-id": "1:4625" },
                        React.createElement("span", { className: "composite-index__legend-swatch composite-index__legend-swatch--stable", "data-node-id": "1:4626", "data-name": "Background+Border", "aria-hidden": true }),
                        React.createElement("p", { className: "composite-index__legend-label", "data-node-id": "1:4627" }, "Good")),
                    React.createElement("div", { className: "composite-index__legend-item" },
                        React.createElement("span", { className: "composite-index__legend-swatch composite-index__legend-swatch--stress", "data-name": "Background+Border", "aria-hidden": true }),
                        React.createElement("p", { className: "composite-index__legend-label" }, "Stress")),
                    React.createElement("div", { className: "composite-index__legend-item", "data-node-id": "1:4631" },
                        React.createElement("span", { className: "composite-index__legend-swatch composite-index__legend-swatch--comp", "data-node-id": "162:2524", "data-name": "Background+Border", "aria-hidden": true }),
                        React.createElement("p", { className: "composite-index__legend-label", "data-node-id": "1:4633" }, "High risk")),
                    React.createElement("div", { className: "composite-index__legend-item" },
                        React.createElement("span", { className: "composite-index__legend-swatch composite-index__legend-swatch--severe-risk", "data-name": "Background+Border", "aria-hidden": true }),
                        React.createElement("p", { className: "composite-index__legend-label" }, "Severe risk")),
                    React.createElement("div", { className: "composite-index__legend-item", "data-node-id": "1:4628" },
                        React.createElement("span", { className: "composite-index__legend-swatch composite-index__legend-swatch--failure", "data-node-id": "162:2522", "data-name": "Background+Border", "aria-hidden": true }),
                        React.createElement("p", { className: "composite-index__legend-label", "data-node-id": "1:4630" }, "Failure"))),
                React.createElement("div", { className: "composite-index__legend-inset", "aria-hidden": true })),
            React.createElement("div", { className: "composite-index__footer-margin", "data-node-id": "1:4634", "data-name": "Margin" },
                React.createElement("div", { className: "composite-index__footer-line", "data-node-id": "1:4635", "data-name": "Paragraph" },
                    React.createElement("div", { className: "composite-index__footer-brand-block", "data-node-id": "1:4636" },
                        React.createElement("p", { className: "composite-index__footer-brand-line" },
                            React.createElement("span", { className: "composite-index__footer-brand-text" }, "RODA BI Composite"),
                            React.createElement("span", { className: "composite-index__footer-brand-space" }, " "))),
                    React.createElement("p", { className: "composite-index__footer-meta", "data-node-id": "1:4637" },
                        avgScore,
                        " ",
                        avgChange.text,
                        " Today"))))));
};
export default CompositeIndex;
